
export class BeforeAfter
{

    constructor(element, strength = 5)
    {
        console.log('before-after');
        this.element = element;
        if (this.element)
        {
            this.image = this.element.querySelector('.js-before-after-image-wrap');
            this.overlay = this.element.querySelector('.js-before-after-banner-overlay');
            this.arrows = this.element.querySelector('.js-before-after-arrows');
            this.width = this.image.clientWidth;
            this.strength = strength;
            this.addEventListeners();
        }
    }

    addEventListeners()
    {
        this.image.addEventListener('mouseenter', this.onMouseEnter.bind(this), false);
        this.image.addEventListener('mouseleave', this.onMouseLeave.bind(this), false);
        this.image.addEventListener('mousemove', this.onMouseMove.bind(this), false);
        window.addEventListener('deviceorientation', this.onDeviceOrientation.bind(this), false);
    }

    changeWidth(width, skip)
    {
        if (skip)
        {
            this.overlay.style.width = `${width}px`;
        }
        else
        {
            this.overlay.style.width = `${this.overlay.clientWidth + width}px`;
        }
    }

    onDeviceOrientation(e)
    {
        const DEG = 65;
        const rotateX = e.gamma;
        const pxPerRotation = this.image.clientWidth / DEG;
        const width = Math.min(this.image.clientWidth, ((this.image.clientWidth / 2) - (rotateX * pxPerRotation)));

        this.changeWidth(width, true);
    }

    onMouseEnter()
    {
        this.arrows.classList.add('hide');
    }

    onMouseLeave()
    {
        this.arrows.classList.remove('hide');
    }

    onMouseMove(e)
    {
        const mouseX = e.pageX,
            width = Math.min(this.image.clientWidth, (mouseX - this.getCoords(this.image).left));

        this.changeWidth(width, true);
    }

    getCoords(elem)
    { // crossbrowser version
        const box = elem.getBoundingClientRect();

        const body = document.body;
        const docEl = document.documentElement;

        const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

        const clientTop = docEl.clientTop || body.clientTop || 0;
        const clientLeft = docEl.clientLeft || body.clientLeft || 0;

        const top  = box.top + scrollTop - clientTop;
        const left = box.left + scrollLeft - clientLeft;

        return { top: Math.round(top), left: Math.round(left) };
    }

}